import { EpicAuthClient } from '@/features/auth/services/EpicAuthClient'
import { getFormInfo } from '@/features/fhirResources/services/FhirR4Client'
import { OrderFormInfoData, Sex } from '@/types/RequisitionFormTypes'

export async function extractFormOrderData(state: string): Promise<OrderFormInfoData> {
  const result = await getFormInfo(state, EpicAuthClient.getInstance())
  // Transform FormInfoResponse to OrderFormInfoData
  const transformedData: OrderFormInfoData = {
    patient: {
      id: (result.patient.id as string) || '',
      name: {
        firstName: result.patient.name?.at(0)?.given?.at(0) || '',
        middleName: result.patient.name?.at(0)?.given?.at(1) || '',
        lastName: result.patient.name?.at(0)?.family || '',
      },
      mrn:
        result.patient.identifier?.find(
          (identifier) => identifier.system === 'urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.14'
        )?.value || '',
      sex: (result.patient.gender as Sex) || Sex.Unknown,
      birthDate: result.patient.birthDate ? new Date(result.patient.birthDate as string) : null,
    },
    medicalProfessionalInfo: {
      npi: result.practitioner_npi || '',
      name: result.practitioner.name?.at(0)?.text || '',
      email: result.practitioner_email || '',
    },
    institution: {
      name: result.organization?.name || '',
      address: {
        street: result.organization?.address?.at(0)?.line?.at(0) || '',
        city: result.organization?.address?.at(0)?.city || '',
        state: result.organization?.address?.at(0)?.state || '',
        zip: result.organization?.address?.at(0)?.postalCode || '',
        country: result.organization?.address?.at(0)?.country || '',
      },
    },
    orderingProvider: {
      name: {
        firstName: result.practitioner.name?.at(0)?.given?.at(0) || '',
        lastName: result.practitioner.name?.at(0)?.family || '',
      },
      roleTitle: result.practitioner.qualification?.at(0)?.code?.coding?.at(0)?.display || '',
      phone: result.practitioner.telecom?.at(0)?.value || '',
      email: result.practitioner_email || '',
      id: result.practitioner.id || '',
    },
  }
  return transformedData
}
